export default __webpack_public_path__ + "static/media/Flag_of_Trinidad_and_Tobago.fae15b9e.svg";